import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'referrerContext',
  namespaced: true,
  state: {
    acctNum: '',
    exitUrl: '',
    workItem: '',
  },
  getters: {
    getField,
    referrerContext: (state) => state,
  },
  mutations: {
    updateField,
  },
};
